import API from '@/services/api';
import router from '@/router';

export default {
  fetchDropoutsByStudent() {
    return API().get(`students/${router.currentRoute.params.id}/dropouts`);
  },
  addDropoutRecord(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/dropouts`,
      params
    );
  },
  updateDropoutRecord(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/dropouts/${params.id}`,
      params
    );
  },
  deleteDropoutRecord(params) {
    return API().delete(
      `students/${router.currentRoute.params.id}/dropouts/${params}`
    );
  },
};
